import { render, staticRenderFns } from "./divisionProportion.vue?vue&type=template&id=864ef39e&scoped=true"
import script from "./divisionProportion.vue?vue&type=script&lang=js"
export * from "./divisionProportion.vue?vue&type=script&lang=js"
import style0 from "./divisionProportion.vue?vue&type=style&index=0&id=864ef39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864ef39e",
  null
  
)

export default component.exports